const DAY_MS = 24 * 60 * 60 * 1000;
const RECENT_DAYS_OFFSET = 3 * DAY_MS;

const normalizeTimestamp = (value: unknown) => {
  const timestamp =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
      ? Number(value)
      : NaN;

  if (!Number.isFinite(timestamp) || timestamp <= 0) {
    return null;
  }

  return timestamp < 1_000_000_000_000 ? timestamp * 1000 : timestamp;
};

export const isRecentCustomerServiceRecord = (createTime: unknown) => {
  const timestamp = normalizeTimestamp(createTime);

  if (timestamp == null) {
    return false;
  }

  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  ).getTime();

  return timestamp >= startOfToday - RECENT_DAYS_OFFSET;
};
